export default __webpack_public_path__ + "static/media/zainLogo.3d2fc832.svg";